/* global OneSignalDeferred */

// Key under which the tags this browser last applied are remembered, so they
// can be removed when a different account signs in on the same machine.
const APPLIED_TAGS_KEY = "onesignal_applied_tags";

/**
 * Stamp the identity the server resolved onto this browser's subscription.
 *
 * `savedevicetoken` answers with the external id and the tag set for the whole
 * household — only the server can resolve siblings, since the browser knows
 * just the account that signed in. Once these are set the backend can address
 * the device by tag, without needing its token stored anywhere.
 *
 * @param {object} data The `data` object from the savedevicetoken response.
 */
export function applyOneSignalIdentity(data) {
  if (!data || typeof data !== "object") return;

  const tags = data.tags && typeof data.tags === "object" ? data.tags : {};
  const externalId = data.external_id ? String(data.external_id) : "";

  if (typeof window === "undefined" || !window.OneSignalDeferred) return;

  OneSignalDeferred.push(async function (OneSignal) {
    try {
      if (externalId) {
        await OneSignal.login(externalId);
      }

      // Tags from a previous account linger on the subscription otherwise, and
      // a stale stu_* tag delivers another family's notifications here.
      let previous = [];
      try {
        previous = JSON.parse(localStorage.getItem(APPLIED_TAGS_KEY)) || [];
      } catch (e) {
        previous = [];
      }

      const stale = previous.filter((key) => !(key in tags));
      if (stale.length > 0) {
        await OneSignal.User.removeTags(stale);
      }

      const keys = Object.keys(tags);
      if (keys.length > 0) {
        await OneSignal.User.addTags(tags);
        localStorage.setItem(APPLIED_TAGS_KEY, JSON.stringify(keys));
      }
    } catch (error) {
      console.error("Failed to apply OneSignal identity:", error);
    }
  });
}
